import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { createAutomationTaskDataForm } from '@tv3/containers/automations/automation-data-form/task/form/automation-task-data-form.component'
import { SaveForm } from '@tokeet-frontend/tv3-platform'
import { AutomationEventTypes } from '@tokeet-frontend/automations'

@Component({
  selector: 'app-automation-task-data-dialog',
  templateUrl: './automation-task-data-dialog.component.html',
  styleUrls: ['./automation-task-data-dialog.component.scss'],
  host: { class: 'modal-content' },
})
export class AutomationTaskDataDialogComponent implements OnInit {
  eventCtrl = new FormControl()
  form = createAutomationTaskDataForm(this.fb, !this.data?.hideDateFields)

  constructor(
    public dialogRef: MatDialogRef<AutomationTaskDataDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { data: any; event: AutomationEventTypes; hideDateFields?: boolean }
  ) {
    this.eventCtrl.setValue(this.data.event)
    this.form.patchValue(this.data.data)
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onSave(form: FormGroup) {
    this.dialogRef.close(form.getRawValue())
  }
}
